/**
 * Single source of truth for NWFA credentials and the canonical
 * business-credential prose fragment.
 *
 * Imported by:
 *  - src/hooks/usePageSEO.ts (runtime LocalBusiness JSON-LD)
 *  - scripts/generate-seo-html.mjs (prerendered LocalBusiness + Organization JSON-LD)
 *
 * Updating any cert name or wording in this file propagates everywhere.
 * Verbatim cert designations sourced from NWFA's current public terminology.
 */

export const NWFA_CREDENTIALS = [
  "NWFA Certified Installer",
  "NWFA Certified Sand & Finisher",
  "NWFA Certified Wood Flooring Inspector",
  "NWFA Certified Sales Advisor",
];

export const ALL_CREDENTIALS = [
  ...NWFA_CREDENTIALS,
  "Licensed Michigan Residential Builder",
];

export const BUSINESS_DESCRIPTION =
  "Licensed Michigan Residential Builder and NWFA-certified Installer, Sand and Finish, Inspector, and Sales Advisor. Full-service project management including licensed plumbing coordination, professional furniture moving, and complete turnkey project delivery across Michigan.";
